
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alu/facade-systems",
      function () {
        return require("private-next-pages/alu/facade-systems/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alu/facade-systems"])
      });
    }
  